import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PermissionService } from "../core/service/permission.service";
import { Permission } from "../core/model/permission";

@Component({
  selector: "app-permission",
  templateUrl: "./permission.component.html",
  styleUrls: ["./permission.component.scss"],
})
export class PermissionComponent implements OnInit, OnDestroy {
  permissions: Permission[];

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getPermissions();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPermissions() {
    this._permissionService
      .getPermissions()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.permissions = (data || []).sort((a, b) =>
            a.code > b.code ? 1 : -1
          );
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  add(): void {
    this._router.navigate(["/parametrage/permission/add-permission"]);
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
